import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/app/App'
import { msalInstance } from '@/lib/auth/msal'

import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root container #root is missing from index.html')

/**
 * MSAL must be initialized, and any pending redirect response consumed,
 * before the app renders — `MsalProvider` assumes both are already done.
 * `msalInstance` is `null` whenever auth is switched off, so there is nothing
 * to wait for in that case.
 */
async function bootstrap(root: HTMLElement) {
  if (msalInstance) {
    await msalInstance.initialize()
    await msalInstance.handleRedirectPromise()
  }

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void bootstrap(container)
